import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/global.css';
import App from './App';
import { apiClient } from './utils/apiClient';
import { initializeErrorSuppression } from './utils/errorSuppression';
// Chrome拡張機能エラー抑制を初期化
initializeErrorSuppression();
// APIクライアントの初期化
const token = localStorage.getItem('teico_token');
if (token) {
    apiClient.setToken(token);
}
const container = document.getElementById('root');
const root = createRoot(container);
root.render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
